module.exports = __webpack_public_path__ + "images/application/dns-record-benefits-2383a90f.svg";